<template>
  <div id="app">
    <template
      v-if="$route.name != 'login' && $route.name != 'forgot-password' && $route.name != 'reset-password' && $route.name != 'privacy-policy'"
    >
      <!--  Body Wrapper -->
      <div
        class="page-wrapper"
        id="main-wrapper"
        data-layout="vertical"
        data-navbarbg="skin6"
        data-sidebartype="full"
        data-sidebar-position="fixed"
        data-header-position="fixed"
      >
        <!-- Sidebar Start -->
        <sidebar/>
        <!--  Sidebar End -->

        <!--  Main wrapper -->
        <div class="body-wrapper">
          <header class="app-header shadow-sm">
            <nav class="navbar navbar-expand-lg navbar-light">
              <ul class="navbar-nav align-items-center gap-2">
                <li class="nav-item d-block d-xl-none">
                  <a class="nav-link sidebartoggler" id="headerCollapse" href="javascript:void(0)">
                    <i class="ti ti-menu-2"></i>
                  </a>
                </li>
                <li class="nav-item d-flex gap-1">
                  <button
                    class="btn btn-outline-warning position-relative text-nowrap"
                    title="Mute"
                    @click="stopNotificationSound"
                  >
                    <i class="ti ti-volume-off fs-6"></i>
                  </button>

                  <router-link
                    class="btn btn-danger position-relative text-nowrap"
                    to="/user-emergencies"
                  >
                    <i class="ti ti-alert-triangle-filled fs-4"></i> DARURAT
                    <span
                      class="position-absolute top-0 start-100 translate-middle badge rounded bg-primary fs-2"
                    >{{countEmergencies}}+</span>
                  </router-link>
                </li>
              </ul>
              <div class="navbar-collapse justify-content-end px-0" id="navbarNav">
                <ul
                  class="navbar-nav flex-row ms-auto align-items-center justify-content-end gap-1"
                >
                  <router-link
                    to="/form-responden?type=responden"
                    class="btn btn-outline-success d-none d-md-inline"
                  >
                    <i class="ti ti-user-plus fs-4"></i> Tambah Responden
                  </router-link>
                  <router-link to="/form-examination" class="btn btn-secondary d-none d-sm-inline">
                    <i class="ti ti-stethoscope fs-4"></i> Tambah Pemeriksaan
                  </router-link>
                  <li class="nav-item dropdown">
                    <a
                      class="nav-link"
                      href="javascript:void(0)"
                      id="drop1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i class="ti ti-bell"></i>
                      <div class="notification bg-primary rounded-circle"></div>
                    </a>
                    <div
                      class="dropdown-menu dropdown-menu-end dropdown-menu-animate-up"
                      aria-labelledby="drop1"
                    >
                      <div class="message-body small px-2">
                        <a
                          v-for="(a,b) in dataNotif.Records"
                          :key="b"
                          href="javascript:void(0)"
                          class="dropdown-item"
                        >
                          <div class="text-dark fw-medium">{{a.content}}</div>
                          <small>Tanggal {{formatDateHour(a.createdAt)}}</small>
                        </a>
                      </div>
                    </div>
                  </li>
                  <li class="nav-item dropdown">
                    <a
                      class="nav-link ps-1"
                      href="javascript:void(0)"
                      id="drop2"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <!-- gambarrrrrr -->
                      <img
                        v-if="preview != ''"
                        :src="preview"
                        alt="preview"
                        width="35"
                        height="35"
                        class="img-fluid rounded-3"
                      >
                      <img
                        v-else-if="preview == ''"
                        src="./assets/images/profile/user-1.jpg"
                        class="img-fluid rounded-3"
                        width="35"
                        height="35"
                        alt="no-img"
                      >
                      <img
                        v-else
                        :src="preview"
                        width="35"
                        height="35"
                        alt="preview"
                        class="img-fluid rounded-3"
                      >
                      <!-- <img
                        src="./assets/images/profile/user-1.jpg"
                        class="img-fluid rounded-3"
                        width="35"
                        height="35"
                        alt="no-img"
                      >-->
                    </a>
                    <div
                      class="dropdown-menu dropdown-menu-end dropdown-menu-animate-up"
                      aria-labelledby="drop2"
                    >
                      <div class="message-body">
                        <router-link
                          to="/my-account"
                          class="d-flex align-items-center gap-2 dropdown-item"
                        >
                          <i class="ti ti-user-circle fs-6"></i>
                          <p class="mb-0 fs-3">Akunku</p>
                        </router-link>
                        <button
                          @click="enableSoundNotif"
                          class="btn btn-success m-3"
                        >Aktifkan Notifikasi</button>
                        <a
                          href
                          @click="onLogout"
                          class="btn btn-outline-warning mx-3 mt-2 d-block"
                        >Keluar</a>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </nav>
          </header>

          <router-view/>
        </div>
      </div>

      <!-- Toast -->
      <div class="toast-container position-fixed bottom-0 end-0 p-3">
        <div
          id="liveToast"
          class="toast text-bg-success"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
        >
          <div class="toast-header gap-1">
            <i class="text-success ti ti-square-rounded-filled fs-6"></i>
            <strong class="me-auto">Bootstrap</strong>
            <small>1 min ago</small>
            <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
          </div>
          <div class="toast-body">Permohonanmu berhasil di proses</div>
        </div>
      </div>
    </template>
    <template v-else-if="$route.name == 'privacy-policy'">
      <div
        class="page-wrapper"
        id="main-wrapper"
        data-layout="vertical"
        data-navbarbg="skin6"
        data-sidebartype="full"
        data-sidebar-position="fixed"
        data-header-position="fixed"
      >
        <div
          class="position-relative overflow-hidden text-bg-light min-vh-100 d-flex align-items-center justify-content-center"
        >
          <div class="d-flex align-items-center justify-content-center">
            <div class="row justify-content-center">
              <div class="col-12">
                <div class="card mb-0">
                  <router-view/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        class="page-wrapper"
        id="main-wrapper"
        data-layout="vertical"
        data-navbarbg="skin6"
        data-sidebartype="full"
        data-sidebar-position="fixed"
        data-header-position="fixed"
      >
        <div
          class="position-relative overflow-hidden text-bg-light min-vh-100 d-flex align-items-center justify-content-center"
        >
          <div class="d-flex align-items-center justify-content-center w-100">
            <div class="row justify-content-center w-100">
              <div class="col-sm-9 col-md-8 col-lg-6 col-xl-4 col-xxl-3">
                <div class="card mb-0">
                  <router-view/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- <router-view name="header"/>
    <router-view/>
    <router-view name="footer"/>-->
    <loader v-if="isLoading"/>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import ModalIdle from './components/ModalIdle'
import { allMixin } from '@/mixins/allMixin.js'
import config from './config'

export default {
	mixins: [allMixin],
	components: {
		loader: () =>
			import(/* webpackChunkName: "c-loader" */
			'@/components/Loader/Loader.vue'),
		sidebar: () =>
			import(/* webpackChunkName: "c-Sidebar" */
			'@/layout/AppSidebar.vue'),
		ModalIdle
	},
	metaInfo: {
		title: 'Klinik',
		titleTemplate: '%s - Home',
		meta: [
			{
				vmid: 'description',
				name: 'description',
				property: 'og:description',
				content: 'Klinik'
			}
		]
	},
	data() {
		return {
			faviconUrl: require('@/assets/favicon.ico'), // default lokal
			logoUrl: require('@/assets/logo_dzikri.png'), // default lokal
			visible: false,
			notificationAudio: null,
			intervalId: null
		}
	},
	created() {
		this.setFavicon(this.faviconUrl)
	},
	methods: {
		fetchNotif() {
			this.$store
				.dispatch('location/getNotif', {
					url: `notif`,
					params: {
						userId: this.isUserLogin.data.id,
						is_read: 0,
						// statusId: 9 //open
						// limit: this.pageSize,
						// order: this.order
						offset: 0,
						limit: 5,
						order: 'desc'
					}
				})
				.then(() => {
					console.log('doneeeeeeeeeee')
				})
		},
		async enableSoundNotif() {
			this.notificationAudio = new Audio('/sound/warning-alarm.wav')
			await this.notificationAudio.play().catch((e) => {
				console.warn('⚠️ Audio tidak bisa autoplay:', e)
			})

			alert('🔊 Suara notifikasi diaktifkan!')
		},
		redirectTo(param) {
			this.$router.push(`/${param}`).catch(() => {})
		},
		scrollTop: function() {
			this.intervalId = setInterval(() => {
				if (window.pageYOffset === 0) {
					clearInterval(this.intervalId)
				}
				window.scroll(0, window.pageYOffset - 50)
			}, 20)
		},
		scrollListener: function(e) {
			this.visible = window.scrollY > 150
		},
		onLogout: function() {
			this.$store
				.dispatch('auth/logout')
				.then((res) => {
					this.$router.push('/login')
				})
				.catch((err) => {})
		},
		navigateTo(to) {
			this.$router.push(to)
		},
		setFavicon(iconPath) {
			let link = document.querySelector("link[rel~='icon']")
			if (!link) {
				link = document.createElement('link')
				link.rel = 'icon'
				document.getElementsByTagName('head')[0].appendChild(link)
			}
			link.href = iconPath
		},
		sendPlayerIdToBackend(playerId) {
			axios
				.post('/api/users/player-id', {
					player_id: playerId
				})
				.then(() => console.log('✅ Player ID dikirim ke backend'))
				.catch((err) => console.error('❌ Gagal kirim Player ID', err))
		},
		stopNotificationSound() {
			if (this.notificationAudio) {
				this.notificationAudio.pause()
				this.notificationAudio.currentTime = 0
				console.log('🛑 Audio stopped')
			}
		},
		playNotificationSound() {
			try {
				// kalau sudah ada audio yang lagi main, stop dulu
				if (this.notificationAudio) {
					this.notificationAudio.pause()
					this.notificationAudio.currentTime = 0
				}

				this.notificationAudio = new Audio('/sound/warning-alarm.wav')
				this.notificationAudio.loop = true // biar bunyi terus sampai di-stop
				this.notificationAudio.play().catch((e) => {
					console.warn('⚠️ Audio tidak bisa autoplay:', e)
				})
			} catch (error) {
				console.error('🎧 Gagal memutar suara:', error)
			}
		},
		async initOneSignal() {
			window.OneSignalDeferred = window.OneSignalDeferred || []

			window.OneSignalDeferred.push(async (OneSignal) => {
				try {
					await OneSignal.init({
						appId: '4bcb5495-508c-4745-bab3-029030e9ea57',
						safari_web_id: 'web.onesignal.auto.456a4abd-b5a3-4365-958f-9af6b49613be',
						notifyButton: {
							enable: true
						}
					})

					console.log('✅ OneSignal initialized')

					const permission = await OneSignal.Notifications.permission
					console.log('🔔 Permission:', permission)

navigator.serviceWorker.register('/OneSignalSDKWorker.js')
  .then(r => console.log("OK:", r))
  .catch(e => console.error("ERR:", e));



					// ambil OneSignal ID
					const playerId = await OneSignal.User.PushSubscription.id
					if (playerId) {
						console.log('🎯 OneSignal ID:', playerId)
						// kirim ke backend via axios.post('/api/save-onesignal-id', { playerId })
					}

					// event ketika notifikasi muncul di tab aktif
					OneSignal.Notifications.addEventListener('foregroundWillDisplay', (event) => {
						console.log('🔔 Notifikasi diterima:', event)
						this.playNotificationSound()
						this.fetchNotif()
					})
				} catch (err) {
					console.error('❌ OneSignal gagal di-init:', err)
				}
			})
		}
	},
	mounted: function() {
		this.initOneSignal()

		this.$store
			.dispatch('location/getConfig', {
				url: `settings/1`
			})
			.then((res) => {
				console.log('respon->>', config('api.baseUrl') + 'storage/uploads/' + res.payload.favicon)
				this.setFavicon(config('api.baseUrl') + 'storage/uploads/' + res.payload.favicon)
			})

		if (this.$route.name != 'login' && this.$route.name != 'forgot-password' && this.$route.name != 'reset-password') {
			if (this.isUserLogin) {
				this.$store
					.dispatch('location/getCountEmergencies', {
						url: `user_emergency`,
						params: {
							// statusId: 9 //open
							// limit: this.pageSize,
							// order: this.order
						}
					})
					.then(() => {
						console.log('doneeeeeeeeeee')
					})

				this.$store
					.dispatch('location/getMyAccount', {
						url: `users/${this.isUserLogin.data.id}`
					})
					.then((res) => {
						console.log('respon->>', res)
					})

				this.fetchNotif()
				// polling tiap 10 detik
				// this.intervalId = setInterval(this.fetchNotif, 10000)
			}
		}

		window.addEventListener('scroll', this.scrollListener)
	},
	beforeDestroy: function() {
		// clearInterval(this.intervalId)
		window.removeEventListener('scroll', this.scrollListener)
	},
	computed: {
		...mapGetters({
			dataUser: 'location/getMyAccount',
			dataNotif: 'location/getNotif',
			countEmergencies: 'location/getcountEmergencies'
		}),
		isUserLogin() {
			return JSON.parse(localStorage.getItem('user_login'))
		},
		isLoading() {
			return this.$store.getters['loader/isLoading']
		},
		isIdle() {
			return this.$store.state.idleVue.isIdle
		},
		preview: {
			// getter
			get() {
				let url = ''
				if (this.dataUser && this.dataUser.user_profile) {
					if (this.dataUser.user_profile.attachment === null || this.dataUser.user_profile.attachment === 'null' || this.dataUser.user_profile.attachment === undefined || this.dataUser.user_profile.attachment === 'undefined' || this.dataUser.user_profile.attachment === '') {
					} else {
						url = config('api.baseUrl') + 'storage/uploads/' + this.dataUser.user_profile.attachment
					}
				} else {
				}
				return url
			},
			set(value) {
				this.dataUser.user_profile.attachment = value
			}
		}
	}
}
</script>
<style lang="scss">
/* @import "~@/assets/style/_variables.scss"; */
// @import "~@/assets/style/main.scss";
.ifr::-webkit-scrollbar {
	display: none;
	width: 0px;
	height: 0px;
}
@media (min-width: 768px) {
	.prev {
		display: none !important;
	}
}
</style>

<style lang="scss">
@media (min-width: 1200px) {
	.container,
	.container-sm,
	.container-md,
	.container-lg,
	.container-xl {
		max-width: 1385px !important;
	}
}
</style>

<style scoped>
@media (min-width: 768px) {
	.bottom-right {
		position: fixed;
		bottom: 50px;
		right: 50px;
		cursor: pointer;
	}
}
@media (max-width: 767.98px) {
	.bottom-right {
		position: fixed;
		bottom: 10px;
		right: 10px;
		cursor: pointer;
	}
}
</style>

<style>
.btn-primary {
	background-color: #e91e63 !important;
	border-color: #e91e63 !important;
}

.btn-primary:hover {
	background-color: #b3174c !important;
	border-color: #b3174c !important;
}
</style>